import { createTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import LoadingComponent from "./app/layout/LoadingComponent";
import { useAppDispatch } from "./app/store/configureStore";
import Dashboard from "./features/Dashboard";
import { fetchDbsAsync } from "./app/store/entrezDbSlice";

function App() {

  
const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(true);

  //since we want this function to be called only once,
  //hence wrapping in useCallBack, as without that it will be treated as new every time this component renders.
  const initApp = useCallback(async () => {
    try {
      //load entrez dbs on app initialization
      await dispatch(fetchDbsAsync());
    } catch (error) {
      console.log(error);
    }
  }, [dispatch]);

  //depends on above callback
  useEffect(() => {
    initApp().then(() => setLoading(false));
  }, [initApp]);

  const [darkMode, setDarkMode] = useState(false);

  const paletteType = darkMode ? "dark" : "light";

  const handleThemeChange = () => {
    setDarkMode(!darkMode);
  };

  const theme = createTheme({
    palette: {
      mode: paletteType,
      background: {
        default: paletteType === "light" ? "#eaeaea" : "#121212",
      },
    },
  });
  //CssBaseline  - to get rid of default style of the browser.

  if (loading) {
    return <LoadingComponent message="Loading..." />;
  }

  return (
    <Dashboard></Dashboard>

    // <ThemeProvider theme={theme}>
    //   <ToastContainer position="bottom-right" hideProgressBar />
    //   <CssBaseline />
    //   <Header darkMode={darkMode} handleThemeChange={handleThemeChange} />
    //   <Route exact path="/" component={HomePage} />

    //   {/* below regular exp means anything else with \ */}
    //   <Route
    //     path={"/(.+)"}
    //     render={() => (
    //       <Container sx={{ mb: 4 }}>
    //         <Switch>
    //           <Route path="/entrez" component={EntrezPage} />
    //           <Route path="/dashboard" component={Dashboard} />
    //           <Route path="/ccdb" component={CCDBEntry} />

    //           <Route path="/server-error" component={ServerError} />

    //           {/* If none of the route matches then if will go with not found route */}
    //           <Route component={NotFound} />
    //         </Switch>
    //       </Container>
    //     )}
    //   />
    // </ThemeProvider>
  );
  //exact is to not to do cascading to next level.
}

export default App;
